// extracted by mini-css-extract-plugin
export default {"main":"styles_main__4fzpY","icons":"styles_icons__8QZw2","icon":"styles_icon__bTqPD"};